import { render } from "./SystemTab.vue?vue&type=template&id=9d40b988"
import script from "./SystemTab.vue?vue&type=script&lang=js"
export * from "./SystemTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__